var map = {
	"./error-page.webp": 2389,
	"./maintanance.webp": 2390,
	"./miscellaneous-bg.webp": 2391,
	"./miscellaneous-mobile-bg.webp": 2392,
	"./restriction.webp": 2393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;